import {EffectPointerPlayer} from "../../../Server/DB/@Shared/EffectPointerPlayer.js";
import {EngineConfig_Signals} from "../../../Server/DB/engineConfigs/@EngineConfig/@EC_Signals.js";
import {LiveSession, TriggerPackage} from "../../LiveSession.js";
import {EngineSessionComp} from "./EngineSessionComp.js";

export class SignalsComp extends EngineSessionComp<EngineConfig_Signals> {
	constructor(session: LiveSession, config: EngineConfig_Signals) {
		super(session, config, s=>config.enabled, s=>s.IsLocal());
	}

	signalEffectPlayers = [] as EffectPointerPlayer[];

	GetTriggerPackages() {
		return this.c.signals.map((signal, i)=>{
			return new TriggerPackage(`Signals_SignalAtIndex${i}`, this.c.signals[i].triggerSet, this, {}, async triggerInfo=>{
				this.s.AsLocal!.AddEvent({type: `Signals.SignalPlay`, signalName: signal.name});

				if (this.signalEffectPlayers[i].effectPointer) {
					this.signalEffectPlayers[i].Play();
				}
			});
		});
	}

	OnStart() {
		this.signalEffectPlayers = this.c.signals.map(signal=> {
			const effectPlayer = new EffectPointerPlayer();
			effectPlayer.effectPointer = signal.effect;
			effectPlayer.OnStart();
			return effectPlayer;
		});
	}
	OnStop() {
		for (const player of this.signalEffectPlayers) {
			player.Stop();
		}
	}

	Suspend() {
		const result = super.Suspend();
		for (const player of this.signalEffectPlayers) {
			player.Stop();
		}
		return result;
	}
}